import request from '@/utils/request'

//平台服务费订单发起收银宝统一主扫支付
export const createPlatformServiceOrderData = (data) => {
    return request.get('/api/bid/order/platformServiceOrder/nativeUnifiedPay', data)
}
// 支付完成主动调取接口确认订单支付状态
export const getPlatformServiceOrderData = (data) => {
    return request.get('/api/bid/order/platformServiceOrder/confirmPayment', data)
}

//半流程平台使用费订单发起收银宝统一主扫支付
export const createSemiPlatformServiceOrderData = (data) => {
    return request.get('/api/bid/order/semiPlatformServiceOrder/nativeUnifiedPay', data)
}

// 半流程支付完成主动调取接口确认订单支付状态
export const getSemiPlatformServiceOrderData = (data) => {
  return request.get('/api/bid/order/semiPlatformServiceOrder/confirmPayment', data)
}

// 根据订单编号查询订单详情
export const getOrderDetail = (data) => {
  return request.get('/api/bid/order/detail', data)
}
